export const InviteLockingPolicies = {
  open: "open",
  locked: "locked",
  // configurable: "configurable",
};
